import {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useState,
  type ReactNode,
} from 'react';
import { getWebSplashMs, isWebSplashEnabled } from '../lib/webSplash';

type WebSplashContextValue = {
  enabled: boolean;
  active: boolean;
};

const WebSplashContext = createContext<WebSplashContextValue>({
  enabled: false,
  active: false,
});

export function WebSplashProvider({ children }: { children: ReactNode }) {
  const enabled = isWebSplashEnabled();
  const [active, setActive] = useState(enabled);

  useEffect(() => {
    if (!enabled) return;
    const timer = window.setTimeout(() => setActive(false), getWebSplashMs());
    return () => window.clearTimeout(timer);
  }, [enabled]);

  const value = useMemo(
    () => ({ enabled, active }),
    [enabled, active],
  );

  return (
    <WebSplashContext.Provider value={value}>{children}</WebSplashContext.Provider>
  );
}

export function useWebSplash() {
  return useContext(WebSplashContext);
}
